import { render, staticRenderFns } from "./InventoryAnalysis.vue?vue&type=template&id=08e5f4dc"
import script from "./InventoryAnalysis.vue?vue&type=script&lang=js"
export * from "./InventoryAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports